module.exports = __webpack_public_path__ + "static/media/popup5-min.25b946f3.png";